export const SHORTS_SRP_VARIANT_COOKIE = 'shorts-srp-variant';
const THIRTY_MINUTES_SECONDS = 60 * 30;

export function useShortsSrpVariant() {
	const route = useRoute();
	const isDevelopment = process.env.NODE_ENV === 'development';
	const cookie = useCookie<'true' | undefined>(SHORTS_SRP_VARIANT_COOKIE, {
		maxAge: THIRTY_MINUTES_SECONDS,
		sameSite: 'lax',
		secure: !isDevelopment,
		refresh: true
	});

	const isSrpRoute = computed(() => route.name === 'PropertiesListing');

	const isShortsSrpVariant = computed(() => {
		if (route.query.shorts === 'true') return true;
		return isSrpRoute.value && cookie.value === 'true';
	});

	watch(
		() => route.query.shorts,
		value => {
			if (isSrpRoute.value && value === 'true') cookie.value = 'true';
		},
		{ immediate: true }
	);

	return { isShortsSrpVariant };
}
